import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';


@Component({
  selector: 'app-business-type-wise-product-price',
  templateUrl: './business-type-wise-product-price.component.html',
  styleUrls: ['./business-type-wise-product-price.component.scss']
})
export class BusinessTypeWiseProductPriceComponent {
  price: any = null;
  value_for = null;

  constructor(
    public dialogRef: MatDialogRef<BusinessTypeWiseProductPriceComponent>,
    @Inject(MAT_DIALOG_DATA) public data, private http: HttpService, private global: GlobalService) {
    console.log(data);
    this.price = data['price'];
    this.value_for = data['value_for'];
  }

  updateDiscountPriceForByProduct() {
    const price_data = {
      'product_id': this.data['product_id'],
      'business_type_id': this.data['business_type_id'],
      'price': this.price,
      'value_for': this.value_for
    };
    this.http.saveOrUpdateBusinessTypeWiseProductDiscountPriceForByProduct(price_data).subscribe((res_data) => {
      console.log(res_data);
      this.global.showSnakeBar('price updated successfully!');
      this.closeComponent(price_data);
    }, (error) => {
      console.log(error);
    });
  }

  closeComponent(data: any) {
    this.dialogRef.close(data);
  }

  ngOnInit() {
  }

}
